import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@store/baseQuery";

export const authApi = createApi({
    reducerPath: "authApi",
    baseQuery: customBaseQuery,
    tagTypes: ["CurrentUser"],
    endpoints: (builder) => ({
        getCurrentUser: builder.query<any, void>({
            query: () => ({
                url: "auth/current-user/",
                method: "GET",
            }),
            providesTags: ["CurrentUser"],
        }),
    }),
});

export const {
    useGetCurrentUserQuery,
    useLazyGetCurrentUserQuery,
} = authApi;